<div class="layout" [class.sidebar-collapsed]="isSidebarCollapsed" [class.mobile-sidebar-open]="isMobileSidebarOpen">

    <button
        type="button"
        class="mobile-sidebar-toggle"
        (click)="toggleMobileSidebar()"
        [attr.aria-expanded]="isMobileSidebarOpen"
        aria-label="Toggle navigation menu">
        <svg *ngIf="!isMobileSidebarOpen" width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 6H20M4 12H20M4 18H20" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
        <svg *ngIf="isMobileSidebarOpen" width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
    </button>

    <div class="mobile-sidebar-backdrop" *ngIf="isMobileSidebarOpen" (click)="closeMobileSidebar()"></div>

    <div class="sidebar-container" [class.collapsed]="isSidebarCollapsed" [class.mobile-open]="isMobileSidebarOpen"
        (mouseover)="onSidebarMouseOver($event)" (mouseout)="onSidebarMouseOut($event)" (mouseleave)="scheduleCloseCollapsedFlyout()">
        <div class="sidebar-header">
            <div class="sidebar-brand" routerLink="/dashboard" style="cursor: pointer;">
                <img src="../../../../../../assets/Logo2.png" alt="Sidebar Logo" />
            </div>
            <div class="user-card">
                <div class="profile-name">Hi, {{ userName }}</div>
                <div class="sidebar-profile">
                    <div class="profile-meta">
                        <span class="profile-role">{{ userRole }}</span>
                        <span class="profile-dot">&#8226;</span>
                        <span class="profile-email">{{ userEmail }}</span>
                    </div>
                </div>
                <p class="sidebar-desc">Manage your campaigns and participants efficiently.</p>
            </div>
        </div>

        <div class="main-sidebar" #sidebarScrollContainer (scroll)="onSidebarScroll($event)"
            (mouseover)="onSidebarHover($event)" [class.is-scrolling]="isSidebarScrolling">
            <!-- Menu search: filters every destination below into a flat list -->
            <div class="menu-search">
                <svg class="menu-search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="1.8" />
                    <path d="M20 20L16.5 16.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
                </svg>
                <input type="text" class="menu-search-input" [(ngModel)]="menuSearch" placeholder="Search menu..."
                    aria-label="Search menu" />
                <button type="button" class="menu-search-clear" *ngIf="isMenuSearching" (click)="clearMenuSearch()"
                    aria-label="Clear search">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                    </svg>
                </button>
            </div>

            <ul class="sidebar-menu search-results" *ngIf="isMenuSearching">
                <li *ngFor="let item of menuSearchResults" (click)="goToMenuResult(item)"
                    [class.active]="isAnyRouteActive([item.route])">
                    <a>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        &nbsp;
                        <span class="search-result-label">
                            {{ item.label }}
                            <small *ngIf="item.group">{{ item.group }}</small>
                        </span>
                    </a>
                </li>
                <li class="search-empty" *ngIf="menuSearchResults.length === 0">
                    <a>No menu item matches "{{ menuSearch }}"</a>
                </li>
            </ul>

            <ul class="sidebar-menu" *ngIf="!isMenuSearching">
                <!-- Section: Main -->
                <!-- Dashboard - Standalone -->
                <li routerLink="/dashboard" routerLinkActive="active" *ngIf="hasPermission('dashboard')">
                    <a routerLink="/dashboard" data-tooltip="Dashboard">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.5 17.5V14.5M11.5 17.5V8.5M16.5 17.5V13.5" stroke="currentColor"
                                stroke-width="1.5" stroke-linecap="round" />
                            <path
                                d="M21.5 5.5C21.5 7.15685 20.1569 8.5 18.5 8.5C16.8431 8.5 15.5 7.15685 15.5 5.5C15.5 3.84315 16.8431 2.5 18.5 2.5C20.1569 2.5 21.5 3.84315 21.5 5.5Z"
                                stroke="currentColor" stroke-width="1.5" />
                            <path
                                d="M21.4955 11C21.4955 11 21.5 11.3395 21.5 12C21.5 16.4784 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4784 2.5 12C2.5 7.52169 2.5 5.28252 3.89124 3.89127C5.28249 2.50003 7.52166 2.50003 12 2.50003L13 2.5"
                                stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        &nbsp;
                        Dashboard
                    </a>
                </li>

                <!-- AI Insights - Standalone -->
                <li routerLink="/ai-insights" routerLinkActive="active" *ngIf="hasPermission('ai-insights')">
                    <a routerLink="/ai-insights" data-tooltip="AI Insights">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 3H15M9 21H15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                            <path d="M12 3V21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                            <circle cx="12" cy="12" r="4" stroke="currentColor" stroke-width="1.5" />
                            <path d="M8 12H4M20 12H16" stroke="currentColor" stroke-width="1.5"
                                stroke-linecap="round" />
                            <path d="M12 8V4M12 20V16" stroke="currentColor" stroke-width="1.5"
                                stroke-linecap="round" />
                        </svg>
                        &nbsp;
                        AI Insights
                    </a>
                </li>

                <!-- Content Management - Parent Menu -->
                <li class="has-submenu" [class.expanded]="isMenuExpanded('content')" [class.active]="isSidebarCollapsed && isChildRouteActive('content')"
                    (mouseenter)="openCollapsedFlyout('content')" (mouseleave)="scheduleCloseCollapsedFlyout()"
                    *ngIf="hasPermission('categories') || hasPermission('quiz') || hasPermission('contest') || hasPermission('task-management')">
                    <a (click)="toggleMenu('content')" class="parent-menu" data-tooltip="Content">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4 6H20M4 12H20M4 18H12" stroke="currentColor" stroke-width="1.5"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        &nbsp;
                        Content
                        <svg class="arrow-icon" width="16" height="16" viewBox="0 0 24 24" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </a>
                    <ul class="submenu" [class.show]="isMenuExpanded('content')"
                        [class.collapsed-flyout-open]="isCollapsedFlyoutOpen('content')"
                        (mouseenter)="openCollapsedFlyout('content')" (mouseleave)="scheduleCloseCollapsedFlyout()"
                        data-menu-title="Content">
                        <li routerLink="/contests" routerLinkActive="active" *ngIf="hasPermission('contest')">
                            <a routerLink="/contests">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6 20V10" stroke="currentColor" stroke-width="1.5"
                                        stroke-linecap="round" />
                                    <path d="M12 20V4" stroke="currentColor" stroke-width="1.5"
                                        stroke-linecap="round" />
                                    <path d="M18 20V14" stroke="currentColor" stroke-width="1.5"
                                        stroke-linecap="round" />
                                </svg>
                                &nbsp; Campaigns
                            </a>
                        </li>
                        <li routerLink="/quiz" routerLinkActive="active" *ngIf="hasPermission('quiz')">
                            <a routerLink="/quiz">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M12 3C7.03 3 3 6.589 3 11C3 15.411 7.03 19 12 19C12.65 19 13.29 18.94 13.91 18.83L18 21V16.71C19.85 15.28 21 13.3 21 11C21 6.589 16.97 3 12 3Z"
                                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                                &nbsp; Quiz
                            </a>
                        </li>
                        <li routerLink="/task-management" routerLinkActive="active"
                            *ngIf="hasPermission('task-management')">
                            <a routerLink="/task-management">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 4H15C15.55 4 16 4.45 16 5V6H8V5C8 4.45 8.45 4 9 4Z"
                                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M6 6H18C19.1 6 20 6.9 20 8V18C20 19.1 19.1 20 18 20H6C4.9 20 4 19.1 4 18V8C4 6.9 4.9 6 6 6Z"
                                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M8 11H16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M8 15H13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                                &nbsp; Task Management
                            </a>
                        </li>
                        <li routerLink="/categories" routerLinkActive="active" *ngIf="hasPermission('categories')">
                            <a routerLink="/categories">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <rect x="3" y="3" width="7" height="7" rx="1.5" stroke="currentColor"
                                        stroke-width="1.5" />
                                    <rect x="14" y="3" width="7" height="7" rx="1.5" stroke="currentColor"
                                        stroke-width="1.5" />
                                    <rect x="3" y="14" width="7" height="7" rx="1.5" stroke="currentColor"
                                        stroke-width="1.5" />
                                    <rect x="14" y="14" width="7" height="7" rx="1.5" stroke="currentColor"
                                        stroke-width="1.5" />
                                </svg>
                                &nbsp; Prize Categories
                            </a>
                        </li>

                    </ul>
                </li>

                <!-- User Management - Parent Menu -->
                <li class="has-submenu" [class.expanded]="isMenuExpanded('users')" [class.active]="isSidebarCollapsed && isChildRouteActive('users')"
                    (mouseenter)="openCollapsedFlyout('users')" (mouseleave)="scheduleCloseCollapsedFlyout()"
                    *ngIf="hasPermission('users') || hasPermission('client')">
                    <a (click)="toggleMenu('users')" class="parent-menu" data-tooltip="User Management">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21"
                                stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="1.5" />
                            <path
                                d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13"
                                stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path
                                d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88"
                                stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        &nbsp;
                        User Management
                        <svg class="arrow-icon" width="16" height="16" viewBox="0 0 24 24" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </a>
                    <ul class="submenu" [class.show]="isMenuExpanded('users')"
                        [class.collapsed-flyout-open]="isCollapsedFlyoutOpen('users')"
                        (mouseenter)="openCollapsedFlyout('users')" (mouseleave)="scheduleCloseCollapsedFlyout()"
                        data-menu-title="User Management">
                        <li routerLink="/users" routerLinkActive="active" *ngIf="hasPermission('users')">
                            <a routerLink="/users">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8C8 10.2091 9.79086 12 12 12Z"
                                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M4 20C4 16.6863 7.58172 14 12 14C16.4183 14 20 16.6863 20 20"
                                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                                &nbsp; Participants
                            </a>
                        </li>
                        <li routerLink="/clients" routerLinkActive="active" *ngIf="hasPermission('client')">
                            <a routerLink="/clients">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M17 21V19C17 16.7909 15.2091 15 13 15H5C2.79086 15 1 16.7909 1 19V21"
                                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="1.5" />
                                    <path d="M23 21V19C22.9986 17.177 21.765 15.5857 20 15.13" stroke="currentColor"
                                        stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M16 3.13C17.7699 3.58317 19.0078 5.17942 19.0078 7.005C19.0078 8.83058 17.7699 10.4268 16 10.88"
                                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                                &nbsp; Clients
                            </a>
                        </li>
                        <li routerLink="/client-qr" routerLinkActive="active" *ngIf="hasPermission('client')">
                            <a routerLink="/client-qr">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <rect x="3" y="3" width="6" height="6" rx="1.2" stroke="currentColor"
                                        stroke-width="1.5" />
                                    <rect x="15" y="3" width="6" height="6" rx="1.2" stroke="currentColor"
                                        stroke-width="1.5" />
                                    <rect x="3" y="15" width="6" height="6" rx="1.2" stroke="currentColor"
                                        stroke-width="1.5" />
                                    <path d="M14 14H14.01M17 14H17.01M14 17H14.01M17 17H17.01M20 14V17"
                                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                                </svg>
                                &nbsp; Client QR
                            </a>
                        </li>
                        <li routerLink="/branding" routerLinkActive="active" *ngIf="hasPermission('client')">
                            <a routerLink="/branding">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C12.83 22 13.5 21.33 13.5 20.5C13.5 20.11 13.35 19.76 13.11 19.49C12.88 19.23 12.73 18.88 12.73 18.5C12.73 17.67 13.4 17 14.23 17H16C19.31 17 22 14.31 22 11C22 6.04 17.51 2 12 2Z"
                                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <circle cx="6.5" cy="11.5" r="1.5" fill="currentColor" />
                                    <circle cx="9.5" cy="7.5" r="1.5" fill="currentColor" />
                                    <circle cx="14.5" cy="7.5" r="1.5" fill="currentColor" />
                                    <circle cx="17.5" cy="11.5" r="1.5" fill="currentColor" />
                                </svg>
                                &nbsp; Branding
                            </a>
                        </li>
                    </ul>
                </li>

                <!-- Communication - Parent Menu -->
                <li class="has-submenu" [class.expanded]="isMenuExpanded('communication')" [class.active]="isSidebarCollapsed && isChildRouteActive('communication')"
                    (mouseenter)="openCollapsedFlyout('communication')" (mouseleave)="scheduleCloseCollapsedFlyout()"
                    *ngIf="hasPermission('notification') || hasPermission('newsletter') || hasPermission('feedback') || hasPermission('email-templates')">
                    <a (click)="toggleMenu('communication')" class="parent-menu" data-tooltip="Communication">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z"
                                stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        &nbsp;
                        Communication
                        <svg class="arrow-icon" width="16" height="16" viewBox="0 0 24 24" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </a>
                    <ul class="submenu" [class.show]="isMenuExpanded('communication')"
                        [class.collapsed-flyout-open]="isCollapsedFlyoutOpen('communication')"
                        (mouseenter)="openCollapsedFlyout('communication')" (mouseleave)="scheduleCloseCollapsedFlyout()"
                        data-menu-title="Communication">
                        <li routerLink="/notification" [queryParams]="{ status: 'history' }" routerLinkActive="active"
                            *ngIf="hasPermission('notification')">
                            <a routerLink="/notification" [queryParams]="{ status: 'history' }">
                                <div style="position: relative; display: inline-flex; align-items: center;"
                                    [class.bell-vibrate]="notificationCount > 0">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M12 2C10.3431 2 9 3.34315 9 5V5.268C6.165 6.14 4 8.828 4 12V17L2 19V20H22V19L20 17V12C20 8.828 17.835 6.14 15 5.268V5C15 3.34315 13.6569 2 12 2Z"
                                            stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                    <span *ngIf="notificationCount > 0" class="notification-badge">
                                        {{ notificationCount }}
                                    </span>
                                </div>
                                &nbsp; Notification
                            </a>
                        </li>
                        <li routerLink="/newsletter" routerLinkActive="active" *ngIf="hasPermission('newsletter')">
                            <a routerLink="/newsletter">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3 7L12 13L21 7" stroke="currentColor" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M4 6H20C21.1 6 22 6.9 22 8V16C22 17.1 21.1 18 20 18H4C2.9 18 2 17.1 2 16V8C2 6.9 2.9 6 4 6Z"
                                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                                &nbsp; Newsletter
                            </a>
                        </li>
                        <li routerLink="/feedback" routerLinkActive="active" *ngIf="hasPermission('feedback')">
                            <a routerLink="/feedback">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10z"
                                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M8 9h8M8 13h5" stroke="currentColor" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                &nbsp; Feedback
                            </a>
                        </li>
                        <li routerLink="/request" routerLinkActive="active" *ngIf="hasPermission('request')">
                            <a routerLink="/request">
                                <div style="position: relative; display: inline-flex; align-items: center;">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6 3H14L18 7V21H6V3Z" stroke="currentColor" stroke-width="1.5"
                                            stroke-linejoin="round" />
                                        <path d="M14 3V7H18" stroke="currentColor" stroke-width="1.5"
                                            stroke-linejoin="round" />
                                        <path d="M8 11H16M8 15H13" stroke="currentColor" stroke-width="1.5"
                                            stroke-linecap="round" />
                                    </svg>
                                    <span *ngIf="requestCount > 0" class="notification-badge">
                                        {{ requestCount }}
                                    </span>
                                </div>
                                &nbsp; Request
                            </a>
                        </li>
                        <li routerLink="/email-templates" routerLinkActive="active" *ngIf="hasPermission('email-templates')">
                            <a routerLink="/email-templates">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3 7L12 13L21 7" stroke="currentColor" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M4 6H20C21.1 6 22 6.9 22 8V16C22 17.1 21.1 18 20 18H4C2.9 18 2 17.1 2 16V8C2 6.9 2.9 6 4 6Z"
                                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M8 11H16M8 14H13" stroke="currentColor" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                &nbsp; Email Templates
                            </a>
                        </li>

                    </ul>
                </li>

                <!-- Analysis & Report - Standalone -->
                <li routerLink="/analysis-reports" routerLinkActive="active" *ngIf="hasPermission('analysis-reports')">
                    <a routerLink="/analysis-reports" data-tooltip="Analysis & Report">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M7 18V16M12 18V15M17 18V13M2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89124C21.5 5.28249 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12Z"
                                stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path
                                d="M5.99219 11.4853C8.14729 11.5571 13.0341 11.2318 15.8137 6.82035M13.9923 6.28738L15.8678 5.98552C16.0964 5.95641 16.432 6.13688 16.5145 6.35201L17.0104 7.99045"
                                stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        &nbsp;
                        Analysis & Report
                    </a>
                </li>

                <!-- Settings & Configuration - Parent Menu -->
                <li class="has-submenu" [class.expanded]="isMenuExpanded('settings')" [class.active]="isSidebarCollapsed && isChildRouteActive('settings')"
                    (mouseenter)="openCollapsedFlyout('settings')" (mouseleave)="scheduleCloseCollapsedFlyout()"
                    *ngIf="hasPermission('policies') || hasPermission('subscription') || hasPermission('terms-condition') || hasPermission('ads') || hasPermission('request') || hasPermission('sectors') || hasPermission('business-subject') || hasPermission('pages') || hasPermission('add-page')">
                    <a (click)="toggleMenu('settings')" class="parent-menu" data-tooltip="Settings & Config">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M12 15.5C13.933 15.5 15.5 13.933 15.5 12C15.5 10.067 13.933 8.5 12 8.5C10.067 8.5 8.5 10.067 8.5 12C8.5 13.933 10.067 15.5 12 15.5Z"
                                stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path
                                d="M19.4 12.94C19.47 12.64 19.5 12.33 19.5 12C19.5 11.67 19.47 11.36 19.4 11.06L21.39 9.47C21.61 9.29 21.67 8.97 21.54 8.72L19.54 5.28C19.41 5.03 19.12 4.93 18.86 5.01L16.45 5.77C15.97 5.45 15.45 5.19 14.89 5L14.5 2.42C14.46 2.18 14.25 2 14 2H10C9.75 2 9.54 2.18 9.5 2.42L9.11 5C8.55 5.19 8.03 5.45 7.55 5.77L5.14 5.01C4.88 4.93 4.59 5.03 4.46 5.28L2.46 8.72C2.33 8.97 2.39 9.29 2.61 9.47L4.6 11.06C4.53 11.36 4.5 11.67 4.5 12C4.5 12.33 4.53 12.64 4.6 12.94L2.61 14.53C2.39 14.71 2.33 15.03 2.46 15.28L4.46 18.72C4.59 18.97 4.88 19.07 5.14 18.99L7.55 18.23C8.03 18.55 8.55 18.81 9.11 19L9.5 21.58C9.54 21.82 9.75 22 10 22H14C14.25 22 14.46 21.82 14.5 21.58L14.89 19C15.45 18.81 15.97 18.55 16.45 18.23L18.86 18.99C19.12 19.07 19.41 18.97 19.54 18.72L21.54 15.28C21.67 15.03 21.61 14.71 21.39 14.53L19.4 12.94Z"
                                stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        &nbsp;
                        Settings & Config
                        <svg class="arrow-icon" width="16" height="16" viewBox="0 0 24 24" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </a>
                    <ul class="submenu" [class.show]="isMenuExpanded('settings')"
                        [class.collapsed-flyout-open]="isCollapsedFlyoutOpen('settings')"
                        (mouseenter)="openCollapsedFlyout('settings')" (mouseleave)="scheduleCloseCollapsedFlyout()"
                        data-menu-title="Settings & Config">
                        <li routerLink="/setting" routerLinkActive="active" [routerLinkActiveOptions]="{ paths: 'exact', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' }" *ngIf="hasPermission('policies')">
                            <a routerLink="/setting">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M19.14 12.94C19.18 12.64 19.2 12.32 19.2 12
           C19.2 11.68 19.18 11.36 19.14 11.06
           L21 9.7L19.3 6.8L17.1 7.5
           C16.6 7.1 16.1 6.8 15.5 6.6
           L15 4H9
           L8.5 6.6
           C7.9 6.8 7.4 7.1 6.9 7.5
           L4.7 6.8L3 9.7L4.86 11.06
           C4.82 11.36 4.8 11.68 4.8 12
           C4.8 12.32 4.82 12.64 4.86 12.94
           L3 14.3L4.7 17.2L6.9 16.5
           C7.4 16.9 7.9 17.2 8.5 17.4
           L9 20H15
           L15.5 17.4
           C16.1 17.2 16.6 16.9 17.1 16.5
           L19.3 17.2L21 14.3L19.14 12.94Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
                                    <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.5" />
                                </svg>
                                &nbsp; Settings
                            </a>
                        </li>


                        <li routerLink="/subscription" routerLinkActive="active" *ngIf="hasPermission('subscription')">
                            <a routerLink="/subscription">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M3.51819 10.3058C3.13013 9.23176 2.9361 8.69476 3.01884 8.35065C3.10933 7.97427 3.377 7.68084 3.71913 7.58296C4.03193 7.49346 4.51853 7.70973 5.49173 8.14227C6.35253 8.52486 6.78293 8.71615 7.18732 8.70551C7.63257 8.69379 8.06088 8.51524 8.4016 8.19931C8.71105 7.91237 8.91861 7.45513 9.33373 6.54064L10.2486 4.52525C11.0128 2.84175 11.3949 2 12 2C12.6051 2 12.9872 2.84175 13.7514 4.52525L14.6663 6.54064C15.0814 7.45513 15.289 7.91237 15.5984 8.19931C15.9391 8.51524 16.3674 8.69379 16.8127 8.70551C17.2171 8.71615 17.6475 8.52486 18.5083 8.14227C19.4815 7.70973 19.9681 7.49346 20.2809 7.58296C20.623 7.68084 20.8907 7.97427 20.9812 8.35065C21.0639 8.69476 20.8699 9.23176 20.4818 10.3057L18.8138 14.9222C18.1002 16.897 17.7435 17.8844 16.9968 18.4422C16.2502 19 15.2854 19 13.3558 19H10.6442C8.71459 19 7.74977 19 7.00315 18.4422C6.25654 17.8844 5.89977 16.897 5.18622 14.9222L3.51819 10.3058Z"
                                        stroke="currentColor" stroke-width="1.5" />
                                    <path d="M12 14H12.009" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M7 22H17" stroke="currentColor" stroke-width="1.5"
                                        stroke-linecap="round" />
                                </svg>
                                &nbsp; Subscription
                            </a>
                        </li>
                        <li routerLink="/terms-condition" routerLinkActive="active"
                            *ngIf="hasPermission('terms-condition')">
                            <a routerLink="/terms-condition">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6 2H14L20 8V22H6V2Z" stroke="currentColor" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M14 2V8H20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M9 13H15" stroke="currentColor" stroke-width="1.5"
                                        stroke-linecap="round" />
                                    <path d="M9 17H15" stroke="currentColor" stroke-width="1.5"
                                        stroke-linecap="round" />
                                </svg>
                                &nbsp; CMS
                            </a>
                        </li>
                        <li routerLink="/ads" routerLinkActive="active" *ngIf="hasPermission('ads')">
                            <a routerLink="/ads">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3 10V14H7L15 19V5L7 10H3Z" stroke="currentColor" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M19 10V14" stroke="currentColor" stroke-width="1.5"
                                        stroke-linecap="round" />
                                </svg>
                                &nbsp; Ads
                            </a>
                        </li>
                        <li routerLink="/sectors" routerLinkActive="active" *ngIf="hasPermission('sectors')">
                            <a routerLink="/sectors">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                &nbsp; Sectors
                            </a>
                        </li>
                        <li routerLink="/interests" routerLinkActive="active">
                            <a routerLink="/interests">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                                        stroke="currentColor" stroke-width="1.5" fill="none"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                &nbsp; Interests
                            </a>
                        </li>
                        <li routerLink="/business-objective" routerLinkActive="active">
                            <a routerLink="/business-objective">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4 4H10V10H4V4Z" stroke="currentColor" stroke-width="1.5"
                                        stroke-linejoin="round" />
                                    <path d="M14 4H20V10H14V4Z" stroke="currentColor" stroke-width="1.5"
                                        stroke-linejoin="round" />
                                    <path d="M4 14H10V20H4V14Z" stroke="currentColor" stroke-width="1.5"
                                        stroke-linejoin="round" />
                                    <path d="M14 14H20V20H14V14Z" stroke="currentColor" stroke-width="1.5"
                                        stroke-linejoin="round" />
                                </svg>
                                &nbsp; Business Objective
                            </a>
                        </li>
                        <li routerLink="/setting/pages" [class.active]="isAnyRouteActive(['/setting/pages', '/setting/add-page'])"
                            *ngIf="isSuperAdmin()">
                            <a routerLink="/setting/pages">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8 3H16L20 7V21H8V3Z" stroke="currentColor" stroke-width="1.5"
                                        stroke-linejoin="round" />
                                    <path d="M16 3V7H20" stroke="currentColor" stroke-width="1.5"
                                        stroke-linejoin="round" />
                                    <path d="M4 7H8M4 12H8M4 17H8" stroke="currentColor" stroke-width="1.5"
                                        stroke-linecap="round" />
                                </svg>
                                &nbsp; Pages
                            </a>
                        </li>
                        <li routerLink="/activity-logs" routerLinkActive="active">
                            <a routerLink="/activity-logs">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 8V12L15 15" stroke="currentColor" stroke-width="1.5"
                                        stroke-linecap="round" />
                                    <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.5" />
                                </svg>
                                &nbsp; Activity Logs
                            </a>
                        </li>
                        <!-- <li routerLink="/referral-config/activity-log" routerLinkActive="active">
                            <a routerLink="/referral-config/activity-log">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 5H7C5.89543 5 5 5.89543 5 7V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V7C19 5.89543 18.1046 5 17 5H15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                                    <rect x="9" y="3" width="6" height="4" rx="1" stroke="currentColor" stroke-width="1.5"/>
                                    <path d="M9 12H15M9 16H13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                                </svg>
                                &nbsp; Referral Activity Log
                            </a>
                        </li> -->
                    </ul>
                </li>

                <!-- Loyalty - Parent Menu -->
                <li class="has-submenu" [class.expanded]="isMenuExpanded('loyalty')" [class.active]="isSidebarCollapsed && isChildRouteActive('loyalty')"
                    (mouseenter)="openCollapsedFlyout('loyalty')" (mouseleave)="scheduleCloseCollapsedFlyout()"
                    *ngIf="hasLoyaltyAccess() && (hasPermission('loyalty') || hasPermission('loyalty-dashboard') || hasPermission('loyalty-system-config') || hasPermission('loyalty-providers') || hasPermission('loyalty-country-config') || hasPermission('loyalty-points-package') || hasPermission('loyalty-marketplace') || hasPermission('loyalty-finance') || hasPermission('loyalty-contest-surplus') || hasPermission('loyalty-notification') || hasPermission('loyalty-user-management') || hasPermission('loyalty-transaction-log') || hasPermission('loyalty-clients-pool-ledger') || hasPermission('loyalty-payment-logs') || hasPermission('loyalty-audit-log'))">
                    <a (click)="toggleMenu('loyalty')" class="parent-menu" data-tooltip="Loyalty">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
                                stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        &nbsp;
                        Loyalty
                        <svg class="arrow-icon" width="16" height="16" viewBox="0 0 24 24" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </a>
                    <ul class="submenu" [class.show]="isMenuExpanded('loyalty')"
                        [class.collapsed-flyout-open]="isCollapsedFlyoutOpen('loyalty')"
                        (mouseenter)="openCollapsedFlyout('loyalty')" (mouseleave)="scheduleCloseCollapsedFlyout()"
                        data-menu-title="Loyalty">
                        <li routerLink="/loyalty/dashboard" routerLinkActive="active" *ngIf="hasPermission('loyalty-dashboard')">
                            <a routerLink="/loyalty/dashboard">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <rect x="3" y="3" width="8" height="8" rx="1.5" stroke="currentColor" stroke-width="1.5" />
                                    <rect x="13" y="3" width="8" height="5" rx="1.5" stroke="currentColor" stroke-width="1.5" />
                                    <rect x="13" y="10" width="8" height="11" rx="1.5" stroke="currentColor" stroke-width="1.5" />
                                    <rect x="3" y="13" width="8" height="8" rx="1.5" stroke="currentColor" stroke-width="1.5" />
                                </svg>
                                &nbsp; Dashboard
                            </a>
                        </li>
                        <li routerLink="/loyalty/system-config" routerLinkActive="active" *ngIf="hasPermission('loyalty-system-config')">
                            <a routerLink="/loyalty/system-config">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 15.5C13.933 15.5 15.5 13.933 15.5 12C15.5 10.067 13.933 8.5 12 8.5C10.067 8.5 8.5 10.067 8.5 12C8.5 13.933 10.067 15.5 12 15.5Z"
                                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M19.4 13C19.2 13.6 19.4 14.3 19.9 14.7L20 14.8C20.6 15.3 20.6 16.2 20 16.8C19.5 17.3 18.6 17.3 18.1 16.8C17.7 16.3 17 16.1 16.4 16.3C15.8 16.5 15.4 17.1 15.4 17.7V18C15.4 18.8 14.7 19.5 13.9 19.5C13.1 19.5 12.4 18.8 12.4 18V17.9C12.4 17.2 12 16.7 11.4 16.5C10.8 16.3 10.1 16.5 9.7 17L9.6 17.1C9.1 17.6 8.2 17.6 7.7 17.1C7.1 16.5 7.1 15.6 7.7 15.1L7.8 15C8.2 14.5 8.4 13.9 8.2 13.3"
                                        stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                &nbsp; System Config
                            </a>
                        </li>
                        <li routerLink="/referral-config" routerLinkActive="active" [routerLinkActiveOptions]="{ paths: 'exact', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' }">
                            <a routerLink="/referral-config">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M16 21V19C16 16.79 14.21 15 12 15H5C2.79 15 1 16.79 1 19V21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                                    <circle cx="8.5" cy="7" r="4" stroke="currentColor" stroke-width="1.5"/>
                                    <path d="M20 8V14M17 11H23" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                                </svg>
                                &nbsp; Referral Config
                            </a>
                        </li>
                        <li routerLink="/loyalty/providers" routerLinkActive="active" *ngIf="hasPermission('loyalty-providers')">
                            <a routerLink="/loyalty/providers">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <rect x="3" y="4" width="18" height="6" rx="1.5" stroke="currentColor" stroke-width="1.5" />
                                    <rect x="3" y="14" width="18" height="6" rx="1.5" stroke="currentColor" stroke-width="1.5" />
                                    <path d="M7 7H7.01M7 17H7.01" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
                                </svg>
                                &nbsp; Providers
                            </a>
                        </li>
                        <li routerLink="/loyalty/country-config" routerLinkActive="active" *ngIf="hasPermission('loyalty-country-config')">
                            <a routerLink="/loyalty/country-config">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.5" />
                                    <path d="M3 12H21M12 3C14.5 5.5 14.5 18.5 12 21C9.5 18.5 9.5 5.5 12 3Z"
                                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                &nbsp; Country Config
                            </a>
                        </li>
                        <li routerLink="/loyalty/system-budget" routerLinkActive="active" *ngIf="hasPermission('loyalty-country-config')">
                            <a routerLink="/loyalty/system-budget">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3 10H21M7 15H9M6 5H18C19.66 5 21 6.34 21 8V16C21 17.66 19.66 19 18 19H6C4.34 19 3 17.66 3 16V8C3 6.34 4.34 5 6 5Z"
                                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                &nbsp; System Budget
                            </a>
                        </li>
                        <li routerLink="/loyalty/points-packages" routerLinkActive="active" *ngIf="hasPermission('loyalty-points-package')">
                            <a routerLink="/loyalty/points-packages">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3 7L12 3L21 7V17L12 21L3 17V7Z" stroke="currentColor" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M3 7L12 11L21 7M12 11V21" stroke="currentColor" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                &nbsp; Points Packages
                            </a>
                        </li>
                        <li routerLink="/loyalty/marketplace" routerLinkActive="active" *ngIf="hasPermission('loyalty-marketplace')">
                            <a routerLink="/loyalty/marketplace">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3 9L4 4H20L21 9M3 9V19C3 19.55 3.45 20 4 20H20C20.55 20 21 19.55 21 19V9M3 9H21M8 9V5M16 9V5"
                                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                &nbsp; Marketplace
                            </a>
                        </li>
                        <li routerLink="/loyalty/finance" routerLinkActive="active" *ngIf="hasPermission('loyalty-finance')">
                            <a routerLink="/loyalty/finance">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.5" />
                                    <path d="M14.5 9.5C14.5 8.4 13.4 7.5 12 7.5C10.6 7.5 9.5 8.4 9.5 9.5C9.5 10.6 10.6 11 12 11C13.4 11 14.5 11.4 14.5 12.5C14.5 13.6 13.4 14.5 12 14.5C10.6 14.5 9.5 13.6 9.5 12.5M12 6V7.5M12 14.5V16"
                                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                &nbsp; Finance
                            </a>
                        </li>
                        <li routerLink="/loyalty/contest-surplus" routerLinkActive="active" *ngIf="hasPermission('loyalty-contest-surplus')">
                            <a routerLink="/loyalty/contest-surplus">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 2l2.5 5 5.5.8-4 3.9.9 5.5L12 14.5 7.1 17.2l.9-5.5-4-3.9L9.5 7 12 2z"
                                        stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
                                </svg>
                                &nbsp; Campaign Surplus
                            </a>
                        </li>
                        <li routerLink="/loyalty/notifications" routerLinkActive="active" *ngIf="hasPermission('loyalty-notification')">
                            <a routerLink="/loyalty/notifications">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 3a6 6 0 0 0-6 6v3l-1.5 3h15L18 12V9a6 6 0 0 0-6-6zM10 19a2 2 0 0 0 4 0"
                                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                &nbsp; Notifications
                            </a>
                        </li>
                        <li routerLink="/loyalty/user-management" routerLinkActive="active" *ngIf="hasPermission('loyalty-user-management')">
                            <a routerLink="/loyalty/user-management">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="12" cy="8" r="4" stroke="currentColor" stroke-width="1.5" />
                                    <path d="M4 20C4 16.69 7.58 14 12 14C16.42 14 20 16.69 20 20" stroke="currentColor"
                                        stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                &nbsp; User Management
                            </a>
                        </li>
                        <li routerLink="/loyalty/transaction-log" routerLinkActive="active" *ngIf="hasPermission('loyalty-transaction-log')">
                            <a routerLink="/loyalty/transaction-log">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 5v14M5 10l7-7 7 7M5 14l7 7 7-7" stroke="currentColor"
                                        stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                &nbsp; Transaction Log
                            </a>
                        </li>
                        <li routerLink="/loyalty/clients-pool-ledger" routerLinkActive="active" *ngIf="hasPermission('loyalty-clients-pool-ledger')">
                            <a routerLink="/loyalty/clients-pool-ledger">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <rect x="2" y="5" width="20" height="14" rx="2" stroke="currentColor" stroke-width="1.5"/>
                                    <path d="M2 9h20M6 13h4M6 16h3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                                    <circle cx="17" cy="14.5" r="2.5" stroke="currentColor" stroke-width="1.5"/>
                                </svg>
                                &nbsp; Clients Pool Ledger
                            </a>
                        </li>
                        <li routerLink="/loyalty/payment-logs" routerLinkActive="active" *ngIf="hasPermission('loyalty-payment-logs')">
                            <a routerLink="/loyalty/payment-logs">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <rect x="2" y="5" width="20" height="14" rx="2" stroke="currentColor" stroke-width="1.5"/>
                                    <path d="M2 10h20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                                    <path d="M7 15h3M14 15h3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                                </svg>
                                &nbsp; Payment Logs
                            </a>
                        </li>
                        <li routerLink="/loyalty/audit-log" routerLinkActive="active" *ngIf="hasPermission('loyalty-audit-log')">
                            <a routerLink="/loyalty/audit-log">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 5H7C5.9 5 5 5.9 5 7V19C5 20.1 5.9 21 7 21H17C18.1 21 19 20.1 19 19V7C19 5.9 18.1 5 17 5H15"
                                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                                    <rect x="9" y="3" width="6" height="4" rx="1" stroke="currentColor" stroke-width="1.5" />
                                    <path d="M9 12H15M9 16H13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                                </svg>
                                &nbsp; Audit Log
                            </a>
                        </li>
                    </ul>
                </li>

                <!-- Super Admin Logs - Standalone (Super Admin Only) -->
                <li routerLink="/super-admin-logs" routerLinkActive="active" *ngIf="isSuperAdmin()">
                    <a routerLink="/super-admin-logs" data-tooltip="Super Admin Logs">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 5H7C5.89543 5 5 5.89543 5 7V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V7C19 5.89543 18.1046 5 17 5H15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                            <rect x="9" y="3" width="6" height="4" rx="1" stroke="currentColor" stroke-width="1.5"/>
                            <path d="M9 12H15M9 16H13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                        </svg>
                        &nbsp;
                        Super Admin Logs
                    </a>
                </li>

                <!-- Profile - Standalone -->
                <li routerLink="/profile" routerLinkActive="active" *ngIf="hasPermission('profile')">
                    <a routerLink="/profile" data-tooltip="Profile">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8C8 10.2091 9.79086 12 12 12Z"
                                stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M4 20C4 16.6863 7.58172 14 12 14C16.4183 14 20 16.6863 20 20" stroke="currentColor"
                                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        &nbsp;
                        Profile
                    </a>
                </li>

                <!-- Logout -->
                <li class="logout-item" (click)="logoutModalVisible = true">
                    <a data-tooltip="Logout">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M15 17.625C14.9264 19.4769 13.3831 21.0494 11.3156 20.9988C10.8346 20.987 10.2401 20.8194 9.05112 20.484C6.18961 19.6768 3.70555 18.3203 3.10956 15.2815C3 14.723 3 14.0944 3 12.8373V11.1627C3 9.90561 3 9.27705 3.10956 8.71846C3.70555 5.67965 6.18961 4.32316 9.05112 3.51603C10.2401 3.18064 10.8346 3.01295 11.3156 3.00119C13.3831 2.95061 14.9264 4.52307 15 6.37501"
                                stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                            <path
                                d="M21 12H10M21 12C21 11.2998 19.0057 9.99153 18.5 9.5M21 12C21 12.7002 19.0057 14.0085 18.5 14.5"
                                stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        &nbsp;
                        Logout
                    </a>
                </li>

            </ul>
        </div>

        <button
            type="button"
            class="sidebar-toggle-btn"
            (click)="toggleSidebarCollapse()"
            aria-label="Toggle sidebar"
            title="Toggle sidebar">
            <svg [class.rotated]="isSidebarCollapsed" width="18" height="18" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
            </svg>
        </button>
    </div>

    <div *ngIf="sidebarTooltipVisible" class="floating-sidebar-tooltip"
        [style.left.px]="sidebarTooltipLeft" [style.top.px]="sidebarTooltipTop">
        {{ sidebarTooltipText }}
    </div>


    <div class="main">
        <router-outlet></router-outlet>
    </div>
</div>

<!-- Mobile Bottom Navigation -->
<nav class="mobile-bottom-nav">
    <a routerLink="/dashboard" routerLinkActive="active" class="bottom-nav-item" *ngIf="hasPermission('dashboard')">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>Home</span>
    </a>
    <a routerLink="/contests" routerLinkActive="active" class="bottom-nav-item" *ngIf="hasPermission('contest')">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <path d="M8 21h8M12 17v4M4 7h16v6a4 4 0 01-4 4H8a4 4 0 01-4-4V7z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M9 7V4h6v3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>Campaigns</span>
    </a>
    <a routerLink="/notification" routerLinkActive="active" class="bottom-nav-item" *ngIf="hasPermission('notification')">
        <div class="nav-icon-wrap">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 01-3.46 0" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span class="nav-badge" *ngIf="notificationCount > 0">{{ notificationCount > 9 ? '9+' : notificationCount }}</span>
        </div>
        <span>Alerts</span>
    </a>
    <a routerLink="/clients" routerLinkActive="active" class="bottom-nav-item" *ngIf="hasPermission('client')">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="1.8"/>
            <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>Clients</span>
    </a>
    <button type="button" class="bottom-nav-item" (click)="toggleMobileSidebar()">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <path d="M4 6h16M4 12h16M4 18h16" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        </svg>
        <span>Menu</span>
    </button>
</nav>

<!-- Logout Confirmation Modal -->
<nz-modal [(nzVisible)]="logoutModalVisible" [nzCentered]="true" [nzFooter]="null" (nzOnCancel)="handleLogoutCancel()"
    nzClassName="pricing-modal" [nzWidth]="'min(520px, calc(100vw - 32px))'">
    <ng-container *nzModalContent>
        <div class="downgrade-modal">
            <h6>Confirm Logout</h6>
            <p>Are you sure you want to logout? You will need to login again to access your account.</p>
            <div class="bottom-btns">
                <button class="btn btn-cancel" (click)="handleLogoutCancel()">Cancel</button>
                <button class="btn btn-downgrade" (click)="handleLogoutConfirm()">Logout</button>
            </div>
        </div>
    </ng-container>
</nz-modal>


